import { BFF_API_ROUTES } from 'constants/apiRoutes';

import { baseRTKApi } from 'shared/api/baseApi';
import type {
  TPreApprovalsSearchApplicationResponse,
  TPreApprovalsSearchApplicationRequest,
} from 'shared/types/TCreditselectionService';

export const sendPreApprovalsSearchApplicationApi = baseRTKApi.injectEndpoints({
  endpoints: (build) => ({
    sendPreApprovalsSearchApplication: build.mutation<
      TPreApprovalsSearchApplicationResponse,
      TPreApprovalsSearchApplicationRequest
    >({
      query: (query) => ({
        url: BFF_API_ROUTES.sendPreApprovalsSearchApplication,
        method: 'POST',
        body: query,
      }),
      extraOptions: { maxRetries: 0 },
    }),
  }),
});
